






















































































































import { Component, Vue, Inject, Ref, Watch } from 'vue-property-decorator';

import RiscossioneList from './RiscossioneList.vue';
import AssignRiscossione from './riscossione/AssignRiscossione.vue';
import { CrudService } from '@/data/services/crud.service';
import RiscossioneFilter from './RiscossioneFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { Offer, OfferPayMode, ShipmentStatus } from '@/data/models/offer.model';
import { User } from '@/data/models/user.model';
import { cloneDeep, debounce } from 'lodash';
import { OfferService } from '@/data/services/offer.service';
import RiscossioneListModal from './RiscossioneListModal.vue';
import AddRiscossione from './riscossione/AddRiscossione.vue';
import { download } from '@/data/utils/helper';
import FattorinoOffer from '../fattorini/fattorino/FattorinoOffer.vue';

@Component({
	components: {
		RiscossioneList,
		AssignRiscossione,
		RiscossioneFilter,
		RiscossioneListModal,
		AddRiscossione
	},
})
export default class Contatti extends Vue {
	@Inject('CrudService') crudService!: CrudService<Offer>;
	@Inject('OfferService') offerService!: OfferService;

	@Ref('list') list!: RiscossioneList;
	@Ref('filter') filter!: RiscossioneFilter;
	@Ref('barcodeinput') barcodeinput!: any;

	state!: State;

	enableAssign: boolean = false;
	enableBarcode: boolean = false;
	enablePrintEnvelope: boolean = false;
	enablePrintBollettini: boolean = false;
	enablePrintIncasso: boolean = false;
	
	selected: Offer[] = [];

	barcodereader: boolean = false;
	barcodevalue: string = '';
	debouncedOnBarcodeChange!: Function;
	barcodeOfferList: Offer[] = [];

	assignmode: boolean = false;

	get buttonLabel(): string {
		return `${this.$t('assign-to')} ${(this.$t('user-type.delivery') as string).toLowerCase()}`;
	}

	constructor() {
		super();
		this.debouncedOnBarcodeChange = debounce(this.onBarcodeAction, 500);
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	@Watch('barcodevalue')
	onValueChange(value: string) {
		this.debouncedOnBarcodeChange(value);
	}

	@Watch('selected', { deep: true })
	onSelectedChange(selected: Offer[]) {
		this.enableAssign = this.assignmode || 
			(selected.length > 0 && selected.every(s => ([ShipmentStatus.TO_BE_ASSIGNED].indexOf(s.shipmentstatus as ShipmentStatus)) >= 0 
			&& s.paymode === OfferPayMode.PAYMENT_METHOD_CASH));
		this.enablePrintEnvelope = selected.length > 0
			&& !selected.some(s => ([ShipmentStatus.NO_PAYMODE].indexOf(s.shipmentstatus as ShipmentStatus)) >= 0);
		this.enablePrintBollettini = selected.length > 0
			&& !selected.some(s => ([ShipmentStatus.NO_PAYMODE].indexOf(s.shipmentstatus as ShipmentStatus)) >= 0);
		this.enablePrintIncasso = selected.length > 0
			&& selected.every(s => ([ShipmentStatus.DELIVERED].indexOf(s.shipmentstatus as ShipmentStatus)) >= 0);
	}

	mounted() {
		this.filter.search();
	}

	onSearch({ search, params }: { search: Search; params: any}) {
		// assegna a fattorino
		this.assignmode = params && (
			params.statuses && params.statuses.length === 1
			&& params.statuses[0] === ShipmentStatus.TO_BE_ASSIGNED
			&& params.paymode === OfferPayMode.PAYMENT_METHOD_CASH);
		// barcode reader
		this.enableBarcode = params && params.statuses && (
			params.statuses.length === 0
			|| params.statuses.indexOf(ShipmentStatus.TO_BE_ASSIGNED) >= 0 
			|| params.statuses.indexOf(ShipmentStatus.ASSIGNED));
		this.list.advancedSearch = search;
		this.selected = [];
		this.onSelectedChange(this.selected);
		this.list.loadData();
	}

	assignRiscossione() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: AssignRiscossione,
			hasModalCard: true,
			canCancel: false,
			customClass: 'dialog',
			events: {
				submit: (value: User) => {
					this.assignToDelivery(value);
					modal.close();
				},
			},
		});
	}

	addRiscossione() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: AddRiscossione,
			hasModalCard: true,
			canCancel: false,
			width: 'large',
			events: {
				submit: () => {
					this.list.loadData();
					modal.close();
				},
			},
		});
	}

	assignToDelivery(value: User, search?: Search) {
		let genericSearch!: Search;

		if (!search) {
			genericSearch = cloneDeep(this.list.advancedSearch);
			genericSearch.table = 'offer';
			if (this.selected.length) genericSearch.addInFilter('id', this.selected.map(c => c.id));
		} else {
			genericSearch = cloneDeep(search);
		}

		this.offerService.linkDeliveryOffers(value.id, genericSearch).then(() => {
			this.selected = [];
			this.onSelectedChange(this.selected);
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
			this.list.loadData();
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	resetBarcodeValue() {
		this.barcodevalue = '';
	}

	showBarCodeReader() {
		this.barcodereader = !this.barcodereader;
		this.barcodeinput.focus();
	}

	onBarcodeAction(value: string) {
		if (!value) return;

		// avoid duplicates
		if (this.barcodeOfferList.filter(o => o.id === Number(value)).length > 0) {
			this.$buefy.notification.open({
				message: this.$t('barcode-already-scan') as string,
				type: 'is-warning',
			});
			this.resetBarcodeValue();
			return;
		}

		this.crudService.getEntity(Offer, 'offer', Number(value)).then((offer: Offer) => {
			const status = [ShipmentStatus.TO_BE_ASSIGNED, ShipmentStatus.ASSIGNED].indexOf(offer.shipmentstatus as ShipmentStatus) >= 0;
			const paymode = offer.paymode === OfferPayMode.PAYMENT_METHOD_CASH;
			if (status && paymode) {
				this.barcodeOfferList.push(offer);
			} else {
				const message = this.$t('offer-status-different-than-assign-paymode', {
					status: (this.$t('offer-status.tobeassigned') as string).toLowerCase(),
					otherstatus: (this.$t('offer-status.assigned') as string).toLowerCase(),
					paymode: (this.$t('offer-paymode.cash') as string).toLowerCase()
				});
				this.$buefy.notification.open({
					message: message as string,
					type: 'is-danger',
				});
			}
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => this.resetBarcodeValue());
	}

	openOfferList() {
		this.$buefy.modal.open({
			parent: this,
			component: RiscossioneListModal,
			hasModalCard: true,
			canCancel: false,
			width: 1280,
			props: {
				offers: this.barcodeOfferList
			},
			events: {
				assign: ({ search, selected }: { search: Search; selected: Offer[]}) => {
					const genericSearch = cloneDeep(search);
					genericSearch.table = 'offer';
					if (selected.length) genericSearch.addInFilter('id', selected.map(s => s.id));

					const modalAssign = this.$buefy.modal.open({
						parent: this,
						component: AssignRiscossione,
						hasModalCard: true,
						canCancel: false,
						customClass: 'dialog',
						events: {
							submit: (value: User) => {
								this.assignToDelivery(value, genericSearch);
								modalAssign.close();
								this.list.loadData();
							},
						},
					});
				},
				print: (offers: Offer[]) => {

					const loading = this.$buefy.loading.open({});
					const ids = offers.map(o => o.id);
					this.offerService.printEnvelopes(ids).then((response) => {
						download(response, 'stampa-buste.pdf');
						this.list.loadData();
					}).catch(({ data }) => {
						if (data) {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						}
					}).finally(() => loading.close());
				}
			},
		});
	}

	printBuste() {
		this.selected = this.selected.filter(o => o.paymode === OfferPayMode.PAYMENT_METHOD_CASH);
		if (!this.selected.length) {
			this.list.loadData();
			return;
		}

		const loading = this.$buefy.loading.open({});
		const ids = this.selected.map(o => o.id);
		this.offerService.printEnvelopes(ids).then((response) => {
			download(response, 'stampa-buste.pdf');
			this.list.loadData();
		}).catch(({ data }) => {
			if (data) {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			}
		}).finally(() => loading.close());
	}

	printBollettini() {
		this.selected = this.selected.filter(o => o.paymode === OfferPayMode.PAYMENT_METHOD_BOLLETTINO);
		if (!this.selected.length) {
			this.list.loadData();
			return;
		}

		const loading = this.$buefy.loading.open({});
		const ids = this.selected.map(o => o.id);
		this.offerService.printBollettino(ids).then((response) => {
			download(response, 'stampa-bolletini.pdf');
			this.list.loadData();
		}).catch(({ data }) => {
			if (data) {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			}
		}).finally(() => loading.close());
	}

	printIncasso() {
		if (!this.selected.length) return;

		const loading = this.$buefy.loading.open({});
		const ids = this.selected.map(o => o.id);
		this.offerService.printIncasso(ids).then((response) => {
			download(response, 'incasso.pdf');
			this.list.loadData();
		}).catch(({ data }) => {
			if (data) {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			}
		}).finally(() => loading.close());
	}

	onDeliveryAction({ offer, action }: { offer: Offer; action: string }) {
		if (action === 'editAmount') {
			const modal = this.$buefy.modal.open({
				parent: this,
				component: FattorinoOffer,
				props: {
					model: offer
				},
				hasModalCard: true,
				canCancel: false,
				events: {
					submit: (value: Offer) => {
						this.crudService.saveEntity(Offer, 'offer', value).then(() => {
							this.$buefy.notification.open({
								message: this.$t('success-save') as string,
								type: 'is-success',
							});
							modal.close();
							this.list.loadData();
						}).catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
					}
				}
			});
		} else {
			this.offerService.setEsito(offer.id, action).then(() => {
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				this.list.loadData();
			}).catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
		}
	}

	onDelete(offer: Offer) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-offer-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Offer, 'offer', offer)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.list.loadData();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			}
		});
	}
}
